import Flicikity from 'flickity';
import { createNextArrow, createPrevArrow } from '../base/carousel';

const elements = Array.from(document.querySelectorAll('.js-pc-carousel'));

elements.forEach(element => createCarousel(element));

function createCarousel(element) {
	if (element.children.length < 2) {
		return;
	}

	new Flicikity(element, {
		contain: true,
		draggable: false,
		pageDots: true,
		wrapAround: true,
	});

	const nextButton = element.querySelector('.flickity-prev-next-button.next');
	const prevButton = element.querySelector('.flickity-prev-next-button.previous');

	nextButton.innerHTML = createNextArrow();
	prevButton.innerHTML = createPrevArrow();
}
